import { HiOutlineIdentification } from "react-icons/hi"
import Section from "../Section"
import './FourthSection.scss'
import Motivation from "./Motivation"
import {
  MdOutlinePayments,
  MdOutlineSearch,
  MdOutlineTipsAndUpdates,
  MdOutlineAssessment,
  MdOutlineNoteAdd,
  MdOutlinePostAdd
} from 'react-icons/md'
import { useState } from "react"

function getWindowSize() {
  const { innerWidth, innerHeight } = window;
  return { innerWidth, innerHeight };
}

let props = {
  size: "65px",
  color: "#fff"
}
const FourthSection = () => {
  const [windowSize] = useState(getWindowSize());

  if (windowSize.innerWidth <= 768) {
    props.size = '55px';
  }

  return (
    <div id="diff">
      <Section title="Por que registrar sua marca com a Spot?">
        <div className="fourth-section-container">
          <div className="motivations-grid">
            <Motivation
              icon={<MdOutlinePayments {...props} />}
              description={'Não cobramos pagamentos adicionais'}
            />

            <Motivation
              icon={<MdOutlineSearch {...props} />}
              description={'Acompanhamento semanal por até 2 anos'}
            />

            <Motivation
              icon={<MdOutlineTipsAndUpdates {...props} />}
              description={'Possuímos equipe especializada'}
            />

            <Motivation
              icon={<MdOutlineAssessment {...props} />}
              description={'Pesquisa de viabilidade gratuita'}
            />

            <Motivation
              icon={<MdOutlineNoteAdd {...props} />}
              description={'Inclusão de manifestação à oposição'}
            />

            <Motivation
              icon={<MdOutlinePostAdd {...props} />}
              description={'Inclusão de recurso em caso de indeferimento'}
            />
          </div>
        </div>
      </Section>
    </div>
  )
}

export default FourthSection